export default {
    PASSWORD_POLICY: "Парольная политика",
    GENERAL_SETTINGS: "Общие настройки",
    VALIDITY_PERIOD: "Срок действия пароля",
    MIN_LENGTH: "Минимальная длина пароля",
    INACTIVITY_PERIOD: "Выход при бездействии в течение",
    CHARACTERS_IN_PASSWORD: "Символы в пароле",
    MAX_INVALID_ATTEMPTS: "Количество неверных попыток входа (для блокировки)",
    LOCK: "Блокировка",
    LOCK_TIME: "Время блокировки",
    IN_MINUTES: "(в минутах)",
    IN_DAYS: "(в днях)",
    DIFFERENT_LETTER_CASES: "Буквы разного регистра",
    EXAMPLE: "пример",
    SPECIAL_CHARACTERS: "Спецсимволы",
    DIGITS: "Цифры",
    CANCEL: "Отменить",
    SAVE: "Сохранить"
};
